export default __webpack_public_path__ + "static/media/noDatafound.b26660be.png";